import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import {
  Grid,
  Table,
  Icon,
  Rating,
  Segment,
  Dimmer,
  Loader,
  Image,
  Button,
  Message,
  Dropdown,
} from 'semantic-ui-react';
import numeral from 'numeral';
import _ from 'lodash';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import TargetLink from '../../components/target-link';
import InfluencerCategoryComponent from '../../components/influencer-category';
import hasRESTClient from '../../hocs/has-rest-client';

import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import hasUserInfo from '../../hocs/has-user-info';

const messageStyles = {
  width: 'max-content',
};

const rejectReasons = [
  { key: 'sexual-content', text: 'Sexual content', value: 'Sexual content' },
  { key: 'low-quality', text: 'Low quality content', value: 'Low quality content' },
  { key: 'selfies-only', text: 'Only selfies', value: 'Only selfies' },
  { key: 'few-posts', text: 'Not many posts', value: 'Not many posts' },
  { key: 'no-reels', text: 'No reels', value: 'No reels' },
  { key: 'low-quality-product', text: 'Low quality product reviewer', value: 'Low quality product reviewer' },
  { key: 'no-face', text: 'Does not show face', value: 'Does not show face' },
  { key: 'beauty-company-owner', text: 'Beauty company owner', value: 'Beauty company owner' },
  { key: 'not-relevant', text: 'Not relevant', value: 'Not relevant' },
  { key: 'wrong-country', text: 'Wrong country', value: 'Wrong country' },
  { key: 'too-family-oriented', text: 'Too family oriented', value: 'Too family oriented' },
  { key: 'another-beauty-service', text: 'Another beauty service', value: 'Another beauty service' },
  { key: 'strong-focus-on-other-topic', text: 'Strong focus on other topic', value: 'Strong focus on other topic' },
];

const dropdownStyles = {
  color: '#1d1937 !important',
  border: '2px solid #1d1937',
  fontWeight: 600,
  height: '46px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

class CreatorApprovalModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      influencer: null,
      influencerDetails: null,
      isLoaded: false,
      isLoading: true,
      isError: false,
      adrModalOpen: false,
      selectedPlatforms: [],
      dataPermission: null,
      isLoadingPermission: true,
    };
  }
  fetchCreator = () => {
    const { influencerId, jsonAPIClient } = this.props;
    this.setState({ isLoading: true });
    jsonAPIClient.get('creators', influencerId).then(response => {
      const resource = response.toJSONTree();
      this.setState({
        influencer: resource,
        influencerDetails: resource,
        isLoaded: true,
        isLoading: false,
        isError: false,
      });
    });
  };

  componentDidMount() {
    this.fetchCreator();
  }
  componentDidUpdate(prevProps) {
    if (this.props.influencerId !== prevProps.influencerId) {
      this.fetchCreator();
    }
  }

  getApprovalsCount = country => {
    const { processedCreatorsData } = this.state;
    const data = _.find(processedCreatorsData, ['country', country]);
    return _.get(data, 'count', '-');
  };

  render() {
    const { influencer, assessment, isLoading } =
      this.state;

    const {
      onClose,
      onApprove,
      onSkip,
      onReject,
      influencerId,
      isPatchingCreator,
      error,
    } = this.props;
    const {
      name,
      thumbnail,
      primarySocialHandle,
      facebookCount,
      instagramCount,
      twitterCount,
      youtubeCount,
      facebook,
      instagram,
      twitter,
      youtube,
      twitch,
      twitchCount,
      tiktok,
      tiktokCount,
      telegramUser,
      instagramLocations,
    } = influencer || {};
    let youtubeSlug;
    if (youtube) {
      const idRegEx = /^UC([a-zA-Z0-9_-]{22})$/;
      const isChannelId = yt => yt.match(idRegEx);
      youtubeSlug = isChannelId(youtube)
        ? `channel/${youtube}`
        : `user/${youtube}`;
    }
    const commaFormat = num => {
      const format = num > 1000000 ? '0.0a' : '0a';
      return numeral(num).format(format);
    };

    const proxyInfluencer = {
      youtubeCount,
      facebookCount,
      instagramCount,
      twitterCount,
    };

    const tiktokIconStyle = {
      width: 15,
      marginTop: 2,
    };

    const IG_CONTENT_TYPES = ['REELS', 'CAROUSEL', 'IMAGE', 'VIDEO', 'IGTV'];
    let mappedLocations = null;
    if (instagramLocations) {
      const groupedLocations = _.groupBy(instagramLocations, 'name');
      mappedLocations = _.map(groupedLocations, (v, k) => ({
        name: k,
        id: _.head(v).id,
        count: v.length,
      }));
    }
    return (
      <div>
        <DyzioModal headerText="Creator Details" onClose={onClose}>
          <div style={isLoading ? { height: '60vh', overflowY: 'auto' } : {}}>
            {isLoading && (
              <div>
                <Dimmer active inverted>
                  <Loader indeterminate>Loading</Loader>
                </Dimmer>
              </div>
            )}
            {error && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  margin: '20px',
                }}
              >
                <Message
                  style={messageStyles}
                  icon="frown"
                  error
                  header="Error"
                  content="Something went wrong. Please try again later."
                />
              </div>
            )}
            {influencer && (
              <div className="flex no-border">
                <div className="item">
                  <Image
                    src={thumbnail}
                    alt={name}
                    size="tiny"
                    shape="circular"
                    spaced="right"
                  />
                </div>
                <div className="space">
                  <h2>
                    {name}&nbsp;&nbsp;
                    <span className="light">{primarySocialHandle}</span>
                  </h2>
                  <div className="spacer small" />
                  <Rating
                    icon="star"
                    rating={assessment}
                    maxRating={5}
                    disabled
                  />
                  <div className="spacer small" />
                  <div>{influencer.instagramBio}</div>
                </div>
                <div className="item">
                  <div className="flex">
                    <div className="space align-center">
                      <TargetLink
                        href={`https://www.facebook.com/${facebook}`}
                        renderIf={Boolean(facebook)}
                      >
                        <img src="/icons/facebook.svg" alt="Facebook" />
                        {facebook && (
                          <p className="light">{commaFormat(facebookCount)}</p>
                        )}
                        {!facebook && (
                          <p className="light">
                            <Icon name="close" color="grey" />
                          </p>
                        )}
                      </TargetLink>
                    </div>
                    <div className="space align-center">
                      <TargetLink
                        href={`https://www.instagram.com/${instagram}`}
                        renderIf={Boolean(instagram)}
                      >
                        <img src="/icons/instagram.svg" alt="Instagram" />
                        {instagram && (
                          <p className="light">{commaFormat(instagramCount)}</p>
                        )}
                        {!instagram && (
                          <p className="light">
                            <Icon name="close" color="grey" />
                          </p>
                        )}
                      </TargetLink>
                    </div>
                    <div className="space align-center">
                      <TargetLink
                        href={`https://www.twitter.com/${twitter}`}
                        renderIf={Boolean(twitter)}
                      >
                        <img src="/icons/twitter.svg" alt="Twitter" />
                        {twitter && (
                          <p className="light">{commaFormat(twitterCount)}</p>
                        )}
                        {!twitter && (
                          <p className="light">
                            <Icon name="close" color="grey" />
                          </p>
                        )}
                      </TargetLink>
                    </div>
                    <div className="space align-center">
                      <TargetLink
                        href={`https://www.youtube.com/${youtubeSlug}`}
                        renderIf={Boolean(youtube)}
                      >
                        <img src="/icons/youtube.svg" alt="YouTube" />
                        {youtube && (
                          <p className="light">{commaFormat(youtubeCount)}</p>
                        )}
                        {!youtube && (
                          <p className="light">
                            <Icon name="close" color="grey" />
                          </p>
                        )}
                      </TargetLink>
                    </div>

                    <div className="space align-center">
                      <TargetLink
                        href={`https://www.twitch.com/${twitch}`}
                        renderIf={Boolean(twitch) && twitchCount}
                      >
                        <Icon name="twitch" color="purple" />
                        {twitch && (
                          <p className="light">{commaFormat(twitchCount)}</p>
                        )}
                        {!twitch && (
                          <p className="light">
                            <Icon name="close" color="grey" />
                          </p>
                        )}
                      </TargetLink>
                    </div>
                    <div className="space align-center">
                      <TargetLink
                        href={`https://www.tiktok.com/@${tiktok}`}
                        renderIf={Boolean(tiktok)}
                      >
                        <img
                          style={tiktokIconStyle}
                          src="https://app.dyzio.co/logos/tiktok-logo.svg"
                          alt="Tiktok"
                        />
                        {tiktok && (
                          <p className="light">{commaFormat(tiktokCount)}</p>
                        )}
                        {!tiktok && (
                          <p className="light">
                            <Icon name="close" color="grey" />
                          </p>
                        )}
                      </TargetLink>
                    </div>
                    <div className="space align-center">
                      <TargetLink
                        href={`https://www.facebook.com/${facebook}`}
                        renderIf={false}
                      >
                        <Icon name="telegram" color="blue" />
                        {telegramUser && (
                          <p className="light">
                            <Icon name="check circle" color="green" />
                          </p>
                        )}
                        {!telegramUser && (
                          <p className="light">
                            <Icon name="close" color="grey" />
                          </p>
                        )}
                      </TargetLink>
                    </div>
                    <div className="space" />
                    <div className="item align-center">
                      <p>
                        <b>Category</b>
                      </p>
                      <InfluencerCategoryComponent
                        influencer={proxyInfluencer}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {influencer && (
              <Segment>
                <Grid columns={3}>
                  <Grid.Row>
                    <Grid.Column width={5}>
                      <h3>Influencer Locations</h3>
                      <Table celled>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>Location</Table.HeaderCell>
                            <Table.HeaderCell>Count</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>
                          {mappedLocations ? (
                            _.map(
                              _.orderBy(mappedLocations, ['count'], ['desc']),
                              h => (
                                <Table.Row key={h.id}>
                                  <Table.Cell>
                                    <a
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={`https://www.instagram.com/explore/locations/${h.id}/`}
                                    >
                                      {h.name}
                                    </a>
                                  </Table.Cell>
                                  <Table.Cell>{h.count}</Table.Cell>
                                </Table.Row>
                              ),
                            )
                          ) : (
                            <Table.Row>
                              <Table.Cell>
                                <p>no locations tagged...</p>
                              </Table.Cell>
                            </Table.Row>
                          )}
                        </Table.Body>
                      </Table>
                    </Grid.Column>

                    <Grid.Column width={6}>
                      <h3>Content Analysis (Last 12 posts)</h3>
                      <Table celled>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>content type</Table.HeaderCell>
                            <Table.HeaderCell>count</Table.HeaderCell>
                            <Table.HeaderCell>Eng. Rate</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>
                          {influencer.instagramBenchmarks ? (
                            _.map(IG_CONTENT_TYPES, ct => (
                              <Table.Row key={ct}>
                                <Table.Cell>{ct}</Table.Cell>
                                <Table.Cell>
                                  {_.get(
                                    influencer.instagramBenchmarks[ct],
                                    'count',
                                    0,
                                  )}
                                </Table.Cell>
                                <Table.Cell>
                                  {_.get(
                                    influencer.instagramBenchmarks[ct],
                                    'engagementRate',
                                    '-',
                                  )}
                                  %
                                </Table.Cell>
                              </Table.Row>
                            ))
                          ) : (
                            <Table.Row>
                              <Table.Cell>
                                <p>not scanned yet...</p>
                              </Table.Cell>
                            </Table.Row>
                          )}
                        </Table.Body>
                      </Table>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <h3>Hashtags (Top 10)</h3>
                      <Table celled>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>Hashtag</Table.HeaderCell>
                            <Table.HeaderCell>Count</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>
                          {influencer.instagramHashtags ? (
                            _.map(
                              _.take(influencer.instagramHashtags, 10),
                              h => (
                                <Table.Row key={h.hashtag}>
                                  <Table.Cell>{h.hashtag}</Table.Cell>
                                  <Table.Cell>{h.count}</Table.Cell>
                                </Table.Row>
                              ),
                            )
                          ) : (
                            <Table.Row>
                              <Table.Cell>
                                <p>not scanned yet...</p>
                              </Table.Cell>
                            </Table.Row>
                          )}
                        </Table.Body>
                      </Table>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            )}
            {influencer && (
              <div
                className="flex"
                style={{
                  justifyContent: 'space-between',
                  padding: '10px 0px 10px 0px',
                }}
              >
                <div>
                  {
                    influencer.elemisApprovalStatus &&
                    <div>Status: {influencer.elemisApprovalStatus}</div>
                  }
                  {
                    influencer.rejectionReason &&
                    <div style={{ color: 'rgba(0,0,0,0.4)' }}>
                      Reason: {influencer.rejectionReason}
                    </div>
                  }
                </div>
                <div className="flex">
                  <Button
                    loading={isPatchingCreator}
                    disabled={isPatchingCreator}
                    basic
                    size="medium"
                    onClick={() => onSkip(influencerId)}
                  >
                    Skip
                  </Button>
                  <Dropdown
                    text="Reject"
                    loading={isPatchingCreator}
                    disabled={isPatchingCreator}
                    basic
                    style={dropdownStyles}
                    button
                    upward
                  >
                    <Dropdown.Menu>
                      {_.map(rejectReasons, reason => <Dropdown.Item
                        {...reason} onClick={() => {
                          onReject(influencerId, reason.value);
                        }}
                      />)}
                    </Dropdown.Menu>
                  </Dropdown>
                  <Button
                    loading={isPatchingCreator}
                    disabled={isPatchingCreator}
                    color="pink"
                    size="medium"
                    onClick={() => onApprove(influencerId)}
                  >
                    Approve
                  </Button>
                </div>
              </div>
            )}
          </div>
        </DyzioModal>
      </div>
    );
  }
}

CreatorApprovalModal.propTypes = {
  influencerId: PropTypes.string.isRequired,
  jsonAPIClient: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  onApprove: PropTypes.func,
  onReject: PropTypes.func,
  onSkip: PropTypes.func,
  isPatchingCreator: PropTypes.bool,
  error: PropTypes.any,
};
CreatorApprovalModal.defaultProps = {
  onClose: _.noop,
  onApprove: _.noop,
  onReject: _.noop,
  onSkip: _.noop,
  isPatchingCreator: false,
  error: null,
};
export default compose(
  hasRESTClient,
  hasJSONAPIClient,
  hasUserInfo,
)(CreatorApprovalModal);



/** WEBPACK FOOTER **
 ** ./src/components/creator-approval-modal/index.js
 **/